import { render, staticRenderFns } from "./JoinTypeCountTable.vue?vue&type=template&id=eb778372&"
import script from "./JoinTypeCountTable.vue?vue&type=script&lang=ts&"
export * from "./JoinTypeCountTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports